<template>
    <DxToolbar>
        <DxItem
            :options="btnMenu"
            location="before"
            widget="dxButton"
        />
        <DxItem
            location="before"
            locate-in-menu="never"
        >
            <h3 class="header__content">{{optionSelected.text}}</h3>
        </DxItem>
    </DxToolbar>
    <DxDrawer
        :opened-state-mode="mobile"
        :position="'left'"
        :reveal-mode="'slide'"
        v-model:opened="openState"
        :close-on-outside-click="false"
        template="listMenu"
        :height="'calc(100vh - 86px)'"
    >
    <template #listMenu>
        <div 
            class="menu dx-theme-accent-as-background-color" 
            style="width: 230px; height: 100%"
        >
            <Menu />
        </div>
    </template>
    <div
        id="content"
        class="dx-theme-background-color"
    > 
        <Grid
            v-if="optionSelected.type === 'grid'"
         />
    </div>
    </DxDrawer>
</template>
<script>
import DxDrawer from 'devextreme-vue/drawer';
import DxRadioGroup from 'devextreme-vue/radio-group';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';

import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';

import Menu from '../components/Menu';
import Grid from '../components/Grid';


export default {
    components: {
        DxDrawer,
        DxRadioGroup,
        DxToolbar,
        DxItem,
        Menu,
        Grid
    },
setup() {
    const store = useStore();
    const openState = ref(true);

    onMounted( async ()=> {
        await store.dispatch('get',{option: 'menu'})
        await store.dispatch('get',{option: 'usuarios', page: 1})
    })

    const btnMenu =  {
        icon: 'menu',
        onClick: () => {
            openState.value = !openState.value
        }
    };

    const optionSelected = computed( ()=> store.state.optionSelect)
    const mobile = computed( () => {
      return  store.state.mobile ? 'overlap' : 'shrink'
    } )

    return {
        openState,
        btnMenu,
        optionSelected,
        mobile,
    }
}
};
</script>
<style scoped>
    .dx-toolbar {
        background-color: rgba(191, 191, 191, .15);
        padding: 5px 10px;
    }

    .dx-list-item-icon-container, .dx-toolbar-before {
        width: 36px;
        padding-right: 0px !important;
        text-align: center;
    }

    .dx-list-item-content {
        padding-left: 10px !important;
    }

    .dx-button {
        background-color: rgba(191, 191, 191, -0.15);
        border: none;
    }

    .panel-list {
        height: 400px;
    }

    .dx-drawer-expand.dx-drawer-right .panel-list {
        float: right;
    }

    .panel-list .dx-list-item {
        color: #fff;
        border-top: 1px solid rgba(221, 221, 221, .2);
    }

    .panel-list .dx-list-item .dx-icon {
        color: #fff !important;
    }

    .options {
        padding: 20px;
        background-color: rgba(191, 191, 191, .15);
    }

    .caption {
        font-size: 18px;
        font-weight: 500;
    }

    .option {
        margin-top: 10px;
        display: inline-block;
        margin-right: 54px;
    }

    label {
        font-weight: bold;
    }

    #content {
        height: 100%;
        overflow: auto;
        padding: 10px 20px; 
    }

    .header__content{
      text-transform: capitalize;
      font-size: 36px;
      margin-left: 20px;
    }

    #content h2 {
        font-size: 26px;
    }
</style>

